import { render, staticRenderFns } from "./SubfolderAddForm.vue?vue&type=template&id=1f0bd094"
import script from "./SubfolderAddForm.vue?vue&type=script&lang=js"
export * from "./SubfolderAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports